__webpack_require__.p = "https://ikea.marat.qd.je/us/en/customer-service/support/";